module.exports = __webpack_public_path__ + "static/media/slideshow-15.988afebd.jpg";